import { useMemo } from 'react'
import { Keybind } from '../../../common/components/keybindings'
import { useAppDispatch } from '../../store/hooks'
import { bookmarksSlice } from './bookmarksSlice'

export function useBookmarkKeybindings() {
  const dispatch = useAppDispatch()

  return useMemo(() => {
    const addBookmark: Keybind = {
      action: () => { dispatch(bookmarksSlice.actions.addDialogToggled({ open: true })) },
      shortcut: 'Ctrl+D',
    }
    const editBookmarks: Keybind = {
      action: () => { dispatch(bookmarksSlice.actions.editDialogToggled({ open: true })) },
      shortcut: 'Ctrl+Shift+D',
    }
    return { addBookmark, editBookmarks }
  }, [dispatch])
}
